import { render } from "./rate.vue?vue&type=template&id=0ebe3625&scoped=true"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"

import "./rate.vue?vue&type=style&index=0&id=0ebe3625&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebe3625"]])

export default __exports__